"use strict";
/* globals module */
/**
 * @module commerceProductFilesRoute
 * @description Baasic Product Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Product Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var _1 = require(".././");
var CommerceProductFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductFilesRoute, _super);
    function CommerceProductFilesRoute(productFilesStreamsRoute, productFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.productFilesStreamsRoute = productFilesStreamsRoute;
        _this.productFilesBatchRoute = productFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/product-files/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/product-files/{id}/{?embed,fields}';
        _this.linkRoute = 'commerce/product-files/link';
        _this.unlinkRoute = 'commerce/product-files/unlink/{id}';
        _this.updateRoute = 'commerce/product-files/{id}';
        return _this;
    }
    Object.defineProperty(CommerceProductFilesRoute.prototype, "streams", {
        get: function () {
            return this.productFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceProductFilesRoute.prototype, "batch", {
        get: function () {
            return this.productFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example ommerceProductFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceProductFilesRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param id Product file id which uniquely identifies product resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example ommerceProductFilesRoute.get({id: '<file-id>'});
     **/
    CommerceProductFilesRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @example commerceProductFilesRoute.link();
     **/
    CommerceProductFilesRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesRoute.unlink(data);
     **/
    CommerceProductFilesRoute.prototype.unlink = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options, 'unlink');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example ommerceProductFilesRoute.update(data);
     **/
    CommerceProductFilesRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b, _c;
    CommerceProductFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CommerceProductFilesBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductFilesStreamsRoute !== "undefined" && _1.CommerceProductFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.CommerceProductFilesBatchRoute !== "undefined" && _1.CommerceProductFilesBatchRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], CommerceProductFilesRoute);
    return CommerceProductFilesRoute;
}(common_1.BaseRoute));
exports.CommerceProductFilesRoute = CommerceProductFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 
